import { FormField, RadioGroup } from "@/ds";
import { DESTINO_LABEL } from "./campo-destino-cancelamento.constants";
import modal from "../planejamento-controle.modal.module.scss";
import type { CampoDestinoCancelamentoProps } from "./types-campo-destino-cancelamento";

const ROTULO = { label: modal.rotuloCampo };

export function CampoDestinoCancelamentoView<T extends string>({
  value,
  onChange,
  opcoes,
  error,
  disabled,
  testId,
  errorTestId,
}: CampoDestinoCancelamentoProps<T>) {
  return (
    <FormField.Root required classNames={ROTULO} error={error} disabled={disabled}>
      <FormField.Label>{DESTINO_LABEL}</FormField.Label>
      <FormField.Control>
        <RadioGroup.Root
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-label={DESTINO_LABEL}
          testId={testId}
        >
          {opcoes.map((opcao) => (
            <RadioGroup.Item
              key={opcao.valor}
              value={opcao.valor}
              label={opcao.label}
              description={opcao.ajuda}
              testId={opcao.testId}
            />
          ))}
        </RadioGroup.Root>
      </FormField.Control>
      <FormField.Error data-testid={errorTestId} />
    </FormField.Root>
  );
}
